/**
 * AdminHub API Service
 * Handles all API calls for P2: AdminHub (Administration)
 */
import apiClient from '../lib/apiClient';

/**
 * Get AdminHub product information
 */
export const getAdminHubInfo = async () => {
  const response = await apiClient.get('/adminhub/');
  return response.data;
};

/**
 * Get system statistics
 */
export const getSystemStats = async () => {
  const response = await apiClient.get('/adminhub/stats');
  return response.data;
};

export const getAdminUsers = async () => {
  const response = await apiClient.get('/adminhub/users');
  return response.data;
};

export const getPendingActions = async () => {
  const response = await apiClient.get('/adminhub/pending');
  return response.data;
};
